
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventi",
      function () {
        return require("private-next-pages/eventi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eventi"])
      });
    }
  